import { useContext, useEffect, useState } from "react";
import Table from "src/components/Table";
import { PiEyeDuotone } from "react-icons/pi";
import { FiEdit } from "react-icons/fi";
import { get, post } from "src/services/HttpClient";
import PermissionBasedComponent from "src/components/PermissionBasedComponent";
import userContext from "src/context/userContext";
import DeleteModal from "src/components/DeleteModal";
import { useNavigate } from "react-router-dom";
import { IoTrashOutline } from "react-icons/io5";
import { LuLogIn } from "react-icons/lu";
import { notify } from "src/services/Notification/Notification";
import axios from "axios";

export default function UserTable() {
    const navigate = useNavigate();

    const { setUser } = useContext(userContext)
    const [data, setData] = useState()
    const [active, setActive] = useState(false)
    const [reload, setReload] = useState(false)
    const [selectedRow, setSelectedRow] = useState()

    const getUser = async () => {
        const result = await get("/user");
        if (result) {
            setUser(result.body);
        }
    };

    const getUsers = async () => {
        const result = await get("/accounts/users");
        setData(result?.body)
    }
    useEffect(() => {
        getUsers();
    }, [reload])

    const columns = [
        {
            id: "email",
            cell: (info) => info.getValue(),
            header: "ایمیل",
        },
        {
            id: "fullName",
            cell: (info) => info.getValue(),
            header: <span>نام کامل</span>,
        },
        {
            id: "role",
            cell: (info) => info.getValue()?.role,
            header: "نقش کاربری",
        },
        {
            id: "id",
            cell: (info) => (
                <div className="flex gap-2">
                    <PermissionBasedComponent permission="editUser">
                        <div
                            className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 dark:bg-gray-700 bg-gray-50 text-gray-400 p-2 rounded-lg"
                            onClick={() => {
                                navigate(
                                    `/app/setting/user-management/user/edit?id=${info.getValue()}`
                                );
                            }}
                        >
                            <FiEdit className="text-blue-500" />
                        </div>
                    </PermissionBasedComponent>
                    <PermissionBasedComponent permission="deleteUser">
                        <div
                            className="cursor-pointer hover:bg-gray-100 hover:text-gray-600 transition-all ease-in-out duration-300 dark:bg-gray-700 bg-gray-50 text-gray-400 p-2 rounded-lg"
                            onClick={() => {
                                setSelectedRow(info.getValue())
                                setActive(true)
                            }}
                        >
                            <IoTrashOutline className="text-red-500" />
                        </div>
                    </PermissionBasedComponent>
                </div>
            ),
            header: "عملیات",
            footer: (info) => info.column.id,
            enableColumnFilter: false,
        },
    ];


    return (
        <>
            <Table data={data} columns={columns} CSVExportPermission="exportUsers" />
            <DeleteModal
                title="حذف کاربر"
                id={selectedRow}
                url="/users"
                active={active}
                setActive={setActive}
                additionalAction={() => { setReload(!reload) }}
            />
        </>
    );
}   
